

import React,{useEffect,useState,useContext} from "react"
import { useLocation, useNavigate } from "react-router-dom"
import FInputt from "../../components/FInputt/FInputt";
import { useFormik } from "formik";
import { usePhoneFormat } from '../../hooks/usePhoneFormat';
import { useSignUpScreen } from "../SignUpScreen/hooks/useSignUpScreen";
import {useRegex} from "../../hooks/useRegex"
import { useProcessor } from "../../hooks/useProcessor";
import {v4 as uuidv4} from 'uuid'
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";

export const NotRegistredScreen = ()=>{

    const route = useNavigate();
    const {state} = useLocation()
    const [idempotencyKey, setIdempotencyKey] = useState(null);
    const {processPayment} = useProcessor()
    const {setAlert} = useContext(AuthContext)

    const { phoneNumberWithEmoji } = usePhoneFormat()

    const {isValidAge} = useRegex()

    useEffect(() => {

        if(state == null){
            route('/')
        }
        setIdempotencyKey(uuidv4());
    },[]);



    const nextScreen = async (data, idempotencyKey) => {
        let response = await processPayment(data, idempotencyKey);
        if( response?.data?.code == "PROCESS_OK"){

            const next = ()=>{
                route('/SendFiadoScreen')
            }
            Swal.fire({
                showCloseButton: true,
                title: 'Éxito',
                text: 'El link se ha enviado correctamente',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                // iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              }).then((result) => {
                if (result.isConfirmed) {
                  next();
                } else{
                  next();
                }
              })

        } else {
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Error",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              })
        }
    }
    


    const formik = useFormik({
        initialValues: {
          name: '',
          dob: '',
          cob: '484',
        },
        onSubmit: (values) => {
            const data = {
                originCurrencyId: "484",
                destinationCurrencyId: "484",
                exchangeRateId: null,
                products: [
                    {
                        id: "FIADO_FUNDS_AVAILABLE_MXN"
                    },
                    {
                        id: "FIADO_SHARE_TRANSITORY_MXN",
                        amount: state.amount,
                        concept: state.concept,
                        beneficiary: {
                            name: values.name,
                            dob: values.dob,
                            countryOfBirthId: values.cob,
                            phoneNumber: state.phoneNumber,
                        }
                    }
                    
                ]
            }
            //console.log(data)
            nextScreen(data, idempotencyKey);
        },
        validate: (values) => {
            console.log(values);
            const errors = {};
            if (!values.name) {
                errors.name = "Necesitas capturar el nombre.";
            } 

            console.log(isValidAge(values.dob))

            if(isValidAge(values.dob) != true){
                errors.dob = 'Fecha de nacimiento inválida.'
            }

            // if (!values.name)
            // if (values.password.inalidate) errors.password = values.password.message;

            // if (values.birthDate.inalidate)
            //     errors.birthDate = values.birthDate.message;
            // if (values.phoneNumber.inalidate)
            //     errors.phoneNumber = values.phoneNumber.message;
            // if (values.name.inalidate) errors.name = values.name.message;

            return errors;
        },
      })



      const {  dataSelectIco2 } = useSignUpScreen();

    

    return(
        <>
        {
            state != null ? 

            
            <div className="w-full">

                <form onSubmit={formik.handleSubmit} >

                    <div className="text-center text-xl p-3">
                        <div className="font-bold">Para: <span className="font-regular">{phoneNumberWithEmoji(state.phoneNumber)}</span></div>
                        <div className="font-bold">Cantidad: <span className="font-regular">${state.amount} MXN</span></div>
                        <div className="font-bold">Concepto: <span className="font-regular">{state.concept}</span></div>  
                    </div>
                    
                    <FInputt type="submit" formik={formik} title={'Enviar Link'} disabled={true}/>

                    <div className="text-center text-sm text-red-600 p-3">
                        Antes de enviar el link ayúdanos con otros tres campos.
                    </div>

                    <FInputt type="text" name="name" formik={formik} title={'Nombre'} placeholder={'Ingresa tu nombre'}/>
                    <FInputt type="DatePicker" name="dob" formik={formik} title={'Fecha de nacimiento'}/>
                    <FInputt type="SelectIcon" value={"484"} name="cob" options={dataSelectIco2} formik={formik} title={'País de nacimiento'}/>


                </form>

            </div> : null
        }
            
        </>
    )
}